/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
/* eslint-disable spire/fenced-imports */
import { CustomChildFieldDefinition, CustomEditorTemplateProps } from "@eisinc/CustomFieldDefinition";
import { getTemplate } from "@insite/shell-public/EditorTemplatesLoader";
import MissingField from "@insite/shell/Components/ItemEditor/MissingField";
import * as React from "react";

export function getEditorTemplate(
    fieldDefinition: Pick<CustomChildFieldDefinition, "editorTemplate">,
    props: CustomEditorTemplateProps<any, CustomChildFieldDefinition>,
) {
    const loadedTemplate = getTemplate(fieldDefinition.editorTemplate);
    if (typeof loadedTemplate !== "undefined") {
        return React.createElement(loadedTemplate, props as any);
    }

    return React.createElement(MissingField, props as any);
}
